import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import { AgentQueryDTO, AgentRequestDTO, AgentResponseDTO } from 'models'
import api from './api'

const { ENDPOINT_API_AGENTS } = environments

const AGENTS_PAGE_LIMIT = 10

export const getAgent = async (
    query?: AgentQueryDTO
): Promise<AxiosResponse<AgentResponseDTO[]>> => {
    return api.get(
        `${ENDPOINT_API_AGENTS}/agentes-financeiros?${new URLSearchParams(
            Object.assign(query ?? {})
        )}`
    )
}

export const getAgentsByState = async (
    uf: string
): Promise<AgentResponseDTO[]> => {
    const firstPage = await getAgent({
        uf,
        pagina: 1,
        limite: AGENTS_PAGE_LIMIT,
        ordenacao: 'razaoSocial',
        tipoOrdenacao: 'ASC'
    })

    const totalPages = Math.max(
        1,
        Number(firstPage.headers['total-pages']) || 1
    )

    if (totalPages === 1) {
        return firstPage.data
    }

    const otherPages = await Promise.all(
        Array.from({ length: totalPages - 1 }, (_, index) =>
            getAgent({
                uf,
                pagina: index + 2,
                limite: AGENTS_PAGE_LIMIT,
                ordenacao: 'razaoSocial',
                tipoOrdenacao: 'ASC'
            })
        )
    )

    return otherPages.reduce(
        (agents, response) => agents.concat(response.data),
        firstPage.data
    )
}

export const getAgentByCNPJandState = async (query?: {
    cnpj: string
    uf: string
}): Promise<AxiosResponse<AgentResponseDTO>> => {
    return api.get(
        `${ENDPOINT_API_AGENTS}/agentes-financeiros/${query?.cnpj}/estados/${query?.uf}`
    )
}

export const createAgent = async (
    data: AgentRequestDTO
): Promise<AxiosResponse<AgentResponseDTO>> => {
    return api.post(`${ENDPOINT_API_AGENTS}/agentes-financeiros`, data)
}

export const removeAgent = async (id: string): Promise<void> => {
    return api.delete(`${ENDPOINT_API_AGENTS}/agentes-financeiros/${id}`)
}

export const editAgent = async (
    data: AgentRequestDTO,
    id: string
): Promise<AxiosResponse<AgentResponseDTO>> => {
    return api.put(`${ENDPOINT_API_AGENTS}/agentes-financeiros/${id}`, data)
}

export const consultAgent = async (
    codigo: string,
    uf: string
): Promise<AxiosResponse<AgentResponseDTO[]>> => {
    return api.get(
        `${ENDPOINT_API_AGENTS}/agentes-financeiros/${codigo}/detrans/${uf}`
    )
}
